module.exports = __webpack_public_path__ + "img/integral-bg.1251770f.png";